import React, { useEffect, useState } from 'react';
import { Row, Tooltip, Input, Popover } from 'antd';
import * as _ from 'lodash';
import NewCopyIcon from 'components/Icons/NewCopyIcon';
import ClosedVariableMenuIcon from 'components/Icons/ClosedVariableMenuIcon';
import VariableInput from './VariableInput';
import VariableCount from './VariableCount';
import VariableEditMenu from './VariableEditMenu';

const VariableItem = ({
  value,
  variable,
  copiedVariable,
  copyVariable,
  onRenameClick,
  deleteCustomVariable,
  errors,
  errorMessage,
  language,
  variableName,
  editCustomVariable,
  saveCustomVariable,
  isSection,
  updateVariable,
  openPopover,
  handleOpenChange,
  isRtl,
  fallbackValueVariable,
  tempPanelDataVariable,
  ...rest
}) => {
  const variableKeyName = `${value}.${variable}`;

  const [panelDataVariable, setPanelValueData] = useState(null);

  useEffect(() => {
    if (!_.isEqual(tempPanelDataVariable, panelDataVariable)) {
      setPanelValueData({ ...tempPanelDataVariable });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tempPanelDataVariable]);

  if (!panelDataVariable) {
    return null;
  }

  return (
    <Row className="items variables-keys">
      {value === 'custom' && errors === variable && updateVariable === variableKeyName && (
        <div className="error-message-variables">{errorMessage}</div>
      )}

      <div className={`head-variables ${language}`}>
        <span className="text">
          {updateVariable === variableKeyName ? (
            <Input
              className={`variable-input3 ${language}`}
              value={variableName}
              maxLength={30}
              onChange={(e) => editCustomVariable(e.target.value, variable)}
              onBlur={() => saveCustomVariable({ code: 'Enter' })}
              onKeyDown={saveCustomVariable}
              placeholder="Enter variable name"
            />
          ) : (
            <div>
              {variableKeyName.length > 19 ? (
                <Tooltip
                  title={variableKeyName}
                  className={`elements-menu-drag ${
                    copiedVariable === variableKeyName ? 'copied' : ''
                  }`}
                  overlayClassName="elements-menu-tooltip">
                  <span className="text">{variableKeyName}</span>
                </Tooltip>
              ) : isSection ? (
                <Tooltip
                  title="Variables added to this section will show the corresponding value when used in a proposal. You can set or change the values when editing your proposal."
                  className={`elements-menu-drag ${
                    copiedVariable === variableKeyName ? 'copied' : ''
                  }`}
                  overlayClassName="elements-menu-tooltip">
                  <span className="text">{variableKeyName}</span>
                </Tooltip>
              ) : (
                <span className="text">{variableKeyName}</span>
              )}

              <VariableCount
                count={fallbackValueVariable?.count || panelDataVariable?.count || 0}
              />
            </div>
          )}
        </span>

        <span className="right-icons">
          {value !== 'custom' ? (
            <Tooltip
              title={copiedVariable === variableKeyName ? 'Copied!' : 'Copy to clipboard'}
              className={`elements-menu-drag ${copiedVariable === variableKeyName ? 'copied' : ''}`}
              overlayClassName="elements-menu-tooltip">
              <div onClick={(e) => copyVariable(value, variable)}>
                <NewCopyIcon className="copy-icon" />
              </div>
            </Tooltip>
          ) : (
            <Popover
              overlayClassName={`variables-popover ${language}`}
              placement={isRtl ? 'topLeft' : 'topRight'}
              trigger="click"
              content={
                <VariableEditMenu
                  {...{
                    copyVariable,
                    onRenameClick,
                    deleteCustomVariable,
                    copiedVariable,
                    value,
                    variable,
                    variableKeyName,
                  }}
                />
              }
              visible={!!openPopover[variable]}
              onClick={handleOpenChange}
              onVisibleChange={(e) => handleOpenChange(variable)}>
              <ClosedVariableMenuIcon className="custom-closed-menu-icon" />
            </Popover>
          )}
        </span>
      </div>
      {!isSection && (
        <VariableInput
          {...{
            isSection,
            value,
            variable,
            language,
            fallbackValueVariable,
            panelDataVariable,
            ...rest,
          }}
        />
      )}
      <span className="spacer" />
    </Row>
  );
};

export default VariableItem;
